const integerFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0,
});

const decimalFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});

/**
 * Some legacy user_calls rows store minutes as thousandths (100 min → 100000).
 * Plain-minute values (e.g. a 1000-minute monthly limit) must not be scaled down,
 * so only divide when the magnitude is clearly in the thousandths range.
 */
const THOUSANDTHS_THRESHOLD = 100000;

export const normalizeUsageMinutes = (rawValue, rawTotal = rawValue) => {
  const value = Math.max(0, Number(rawValue) || 0);
  const total = Math.max(0, Number(rawTotal) || 0);

  if (total >= THOUSANDTHS_THRESHOLD || value >= THOUSANDTHS_THRESHOLD) {
    return value / 1000;
  }

  return value;
};

export const formatUsageCount = (value) => (
  integerFormatter.format(Math.max(0, Math.round(Number(value) || 0)))
);

export const formatUsageMinutes = (minutes) => {
  const value = Math.max(0, Number(minutes) || 0);
  const rounded = Math.round(value * 10) / 10;

  if (rounded > 0 && rounded < 10 && !Number.isInteger(rounded)) {
    return decimalFormatter.format(rounded);
  }

  return integerFormatter.format(Math.round(rounded));
};
